export const FETCH_APPS = "FETCH_APPS";
export const FETCH_APPS_SUCCESS = "FETCH_APPS_SUCCESS";
export const FETCH_APPS_FAILED = "FETCH_APPS_FAILED";
